var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-monitor',{attrs:{"data":_vm.data,"idKey":_vm.idKey,"constants":_vm.constants}})
}
var staticRenderFns = []

export { render, staticRenderFns }